<!-- materials-main -->
<template>
  <div class="ugd-attention-wrapper">
    <div class='cn-container'>
      <div class='cv-menu'>
        <div class='cv-menu-container'>
          <ul>
            <li v-for='(item, index) in list'
                :key="item.title"
                :class="[(item.title === activeName) ? 'active' : '']"
                @click="goInfo(item)">{{index + 1}}.&nbsp;{{item.title}}
            </li>
          </ul>
        </div>
      </div>
      <div class='cv-main'>
        <iframe :src="currentUrl"
                frameborder="0"></iframe>
      </div>
    </div>
  </div>
</template>

<script>
import materials from '@/constant/ugd-materials'

export default {
  name: 'meterials-main',
  data () {
    return {
      menuList: [],
      list: [],
      curMenu: {},
      activeName: '',
      currentUrl: undefined
    }
  },
  mounted () {
    this.makeMaterials()
  },
  methods: {
    makeMaterials () {
      this.list = materials
      this.currentUrl = materials[0].url
      this.activeName = materials[0].title
    },
    goInfo (item) {
      this.activeName = item.title
      this.currentUrl = item.url
    }
  }
}
</script>
<style lang='less' scoped>
iframe {
  width: 960px;
  min-height: calc(100vh);
}
.attachments-down {
  li {
    padding: 10px;
  }
}
.cv-menu-container li {
  width: 300px;
  height: 40px;
  padding-left: 8px;
  padding-right: 8px;
  cursor: pointer;
  font-size: 14px;
  color: #667483;
  letter-spacing: 0;
  line-height: 40px;
  &.active {
    background-image: linear-gradient(12deg, #4aa6ff 0%, #4980fd 100%);
    border-radius: 8px;
    color: #fff;
  }
}

.ugd-attention-wrapper {
  margin: 0 auto;
  padding: 60px 20px 120px;
  width: 1240px;
  .cn-container {
    display: flex;
    .cv-menu {
      flex: 0 0 200px;
      padding-right: 20px;
      height: 40px;
    }
    .cv-main {
      background: #FFFFFF;
      border-radius: 8px;
      flex: 1;
    }
  }
}
</style>
